import { createAction, props } from '@ngrx/store';

import { IFormMode } from '../../types/IFormMode';
import { MerchantSubscription } from '../../../core/domain/merchant-subscription/merchant-subscription';

export const openMerchantSubscriptionModal = createAction(
  '[MerchantSubscription Modal] Open Modal',
  props<{
    mode: IFormMode;
    merchantId: string;
    merchantSubscription?: MerchantSubscription;
  }>()
);

export const closeMerchantSubscriptionModal = createAction(
  '[MerchantSubscription Modal] Close Modal'
);
